export default __webpack_public_path__ + "static/media/pagenotfound.390998f6.svg";